import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { LeaderboardPage } from './pages/LeaderboardPage'
import { HUDPage } from './pages/HUDPage'
import { StandingsPage } from './pages/overlays/StandingsPage'
import { TimerPage } from './pages/overlays/TimerPage'
import { BestLapPage } from './pages/overlays/BestLapPage'
import { LowerThirdPage } from './pages/overlays/LowerThirdPage'
import { TickerPage } from './pages/overlays/TickerPage'
import './global.css'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Main displays */}
        <Route path="/" element={<LeaderboardPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/hud" element={<HUDPage />} />

        {/* OBS Overlays */}
        <Route path="/overlay/standings" element={<StandingsPage />} />
        <Route path="/overlay/timer" element={<TimerPage />} />
        <Route path="/overlay/best-lap" element={<BestLapPage />} />
        <Route path="/overlay/lower-third" element={<LowerThirdPage />} />
        <Route path="/overlay/ticker" element={<TickerPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
